import { AuditLogRepository } from '../ports/AuditLogRepository';
import { AuditLogResult } from '../domain/entities/AuditLogResult';

export class FetchAuditLogsUseCase {
  constructor(private readonly auditLogRepository: AuditLogRepository) {}

  async execute(i9FormId: string, page: number, pageSize: number): Promise<AuditLogResult> {
    return this.auditLogRepository.fetchAuditLogs(i9FormId, page, pageSize);
  }
}
